(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefl-blog-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var article = document.getElementById('tefl-article');
    if (!article) return;

    // Wrap each table so wide ones scroll horizontally instead of overflowing the body
    Array.prototype.forEach.call(article.querySelectorAll('table'), function (t) {
      var p = t.parentNode;
      if (!p || (p.classList && p.classList.contains('tefl-blog-content__table-scroll'))) return;
      var wrap = document.createElement('div');
      wrap.className = 'tefl-blog-content__table-scroll';
      p.insertBefore(wrap, t);
      wrap.appendChild(t);
    });

    // Inline "Editor's note:" callouts authored in the body
    var blocks = article.querySelectorAll('blockquote, p');
    Array.prototype.forEach.call(blocks, function (el) {
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt.indexOf("editor's note") === 0 || txt.indexOf('editor’s note') === 0) {
        el.classList.add('tefl-blog-note');
      }
    });

    // Match plain blockquotes to the chosen block-quote colour scheme (editor setting)
    var bqScheme = article.getAttribute('data-bq-scheme') || 'scheme-1';
    Array.prototype.forEach.call(article.querySelectorAll('blockquote'), function (bq) {
      if (!bq.classList.contains('tefl-blog-note')) bq.classList.add('color-' + bqScheme);
    });

    // Table of contents (H2s only) — sidebar on desktop, inline after intro on mobile
    var toc = document.getElementById('tefl-toc');
    if (!toc) return;
    var heads = article.querySelectorAll('h2');
    if (heads.length < 2) {
      // Fall back to H3s for articles authored without an H2 structure (keeps H2-only when H2s exist)
      var h3s = article.querySelectorAll('h3');
      if (h3s.length >= 2) { heads = h3s; }
    }
    if (heads.length < 2) { toc.parentNode && toc.parentNode.removeChild(toc); return; }

    var used = {};
    function slug(t) {
      var srcVal = (t || '').toLowerCase().trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      if (!srcVal) srcVal = 'section';
      if (used[srcVal] != null) { used[srcVal]++; srcVal = srcVal + '-' + used[srcVal]; } else { used[srcVal] = 0; }
      return srcVal;
    }

    var ul = document.createElement('ul');
    ul.className = 'tefl-toc__list';
    Array.prototype.forEach.call(heads, function (h) {
      if (!h.id) h.id = slug(h.textContent);
      var li = document.createElement('li');
      li.className = 'tefl-toc__item';
      var a = document.createElement('a');
      a.className = 'tefl-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      ul.appendChild(li);
    });

    var title = document.createElement('p');
    title.className = 'tefl-toc__title';
    title.textContent = toc.getAttribute('data-title') || 'In this article';
    toc.appendChild(title);
    toc.appendChild(ul);
    toc.hidden = false;

    // Responsive placement: sidebar (desktop) vs inline after the intro (mobile)
    var sidebarMount = toc.parentNode;
    var firstHeading = heads[0];
    var mq = window.matchMedia('(max-width: 999px)');
    function place() {
      if (mq.matches) {
        if (firstHeading && firstHeading.parentNode === article && toc.parentNode !== article) {
          article.insertBefore(toc, firstHeading);
        }
        toc.classList.add('tefl-blog-content__toc--inline');
      } else {
        if (sidebarMount && toc.parentNode !== sidebarMount) {
          sidebarMount.insertBefore(toc, sidebarMount.firstChild);
        }
        toc.classList.remove('tefl-blog-content__toc--inline');
      }
    }
    place();
    if (mq.addEventListener) { mq.addEventListener('change', place); }
    else if (mq.addListener) { mq.addListener(place); }

    // Scroll-spy: highlight the section currently in view
    var map = {};
    Array.prototype.forEach.call(toc.querySelectorAll('.tefl-toc__link'), function (a) {
      map[a.getAttribute('href').slice(1)] = a;
    });
    var activeId = null;
    function setActive(id) {
      if (id === activeId) return;
      if (activeId && map[activeId]) map[activeId].classList.remove('is-active');
      activeId = id;
      if (id && map[id]) map[id].classList.add('is-active');
    }
    // Total sticky chrome = header + announcement bar (announcement var only set while the bar is active)
    function topChrome() {
      var cs = getComputedStyle(document.body);
      var hh = parseFloat(cs.getPropertyValue('--header-height')) || 0;
      var ah = parseFloat(cs.getPropertyValue('--tefl-ann-h')) || 0;
      return hh + ah;
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var line = topChrome() + 24;
        var current = heads[0];
        for (var i = 0; i < heads.length; i++) {
          if (heads[i].getBoundingClientRect().top - line <= 0) {
            current = heads[i];
          } else {
            break;
          }
        }
        setActive(current ? current.id : null);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tefl-internship-overview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__teflInternshipOverviewInit) return;
    window.__teflInternshipOverviewInit = true;

    var MOBILE_BP = 750;

    function isMobile() {
      return window.matchMedia('(max-width: ' + (MOBILE_BP - 1) + 'px)').matches;
    }

    function selectTab(root, tabKey) {
      // Desktop: swap panels by hidden attribute
      var tabs = root.querySelectorAll('.tefl-internship-overview__tab');
      var panels = root.querySelectorAll('.tefl-internship-overview__panel');
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tio-tab') === tabKey;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-tio-panel') === tabKey;
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }

    function toggleMobilePanel(toggleBtn) {
      var panel = toggleBtn.closest('.tefl-internship-overview__panel');
      var bodyId = toggleBtn.getAttribute('aria-controls');
      var body = bodyId ? document.getElementById(bodyId) : null;
      if (!panel || !body) return;
      var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        body.setAttribute('hidden', '');
      } else {
        toggleBtn.setAttribute('aria-expanded', 'true');
        body.removeAttribute('hidden');
      }
    }

    // On mobile we need all panels visible (tabs ignored) but their bodies
    // collapsed by default except the first; on desktop only the active
    // panel visible. Reset state when crossing the breakpoint.
    function applyResponsiveState(root) {
      var panels = root.querySelectorAll('.tefl-internship-overview__panel');
      if (isMobile()) {
        // Show all panels, collapse all bodies except the first
        panels.forEach(function (p, idx) {
          p.removeAttribute('hidden');
          var body = p.querySelector('.tefl-internship-overview__panel-body');
          var toggle = p.querySelector('.tefl-internship-overview__mobile-toggle');
          if (!body || !toggle) return;
          if (idx === 0) {
            body.removeAttribute('hidden');
            toggle.setAttribute('aria-expanded', 'true');
          } else {
            body.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      } else {
        // Desktop: ensure tab-selected panel shown, others hidden;
        // bodies always visible inside their panel.
        panels.forEach(function (p) {
          var body = p.querySelector('.tefl-internship-overview__panel-body');
          if (body) body.removeAttribute('hidden');
        });
        var activeTab = root.querySelector('.tefl-internship-overview__tab[aria-selected="true"]');
        var activeKey = activeTab ? activeTab.getAttribute('data-tio-tab') : null;
        if (activeKey) selectTab(root, activeKey);
      }
    }

    function init(root) {
      // Desktop tab clicks
      root.querySelectorAll('.tefl-internship-overview__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          selectTab(root, tab.getAttribute('data-tio-tab'));
        });
      });
      // Mobile accordion clicks
      root.querySelectorAll('.tefl-internship-overview__mobile-toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!isMobile()) return; // tabs handle desktop
          toggleMobilePanel(btn);
        });
      });
      applyResponsiveState(root);
    }

    function initAll() {
      document.querySelectorAll('.tefl-internship-overview').forEach(function (root) {
        if (root.__tioReady) return;
        root.__tioReady = true;
        init(root);
      });
    }

    // Re-evaluate on resize so the tab-vs-accordion state is correct
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('.tefl-internship-overview').forEach(applyResponsiveState);
      }, 100);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Re-init when sections are added in the theme editor
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
